import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Phone, PencilRuler, Package2, CalendarDays, FileBarChart2 } from 'lucide-react';

/**
 * TopNav — primary navigation (Overview / Deliverables / Meetings / Reports).
 *
 * "Site Office" restyle: renders BOTH the desktop left rail (.rail, numbered
 * 01–04) and the mobile bottom tab bar (.bbar) from the same TABS list and
 * the same routing/active-tab state — global.css media queries decide which
 * one is visible (.rail hidden / .bbar flex under 900px), so there is no JS
 * breakpoint logic here, same as before.
 */
const TABS = [
  { to: '/',             label: 'Overview',     Icon: LayoutDashboard, end: true  },
  { to: '/calls',        label: 'Calls',        Icon: Phone,           end: false },
  { to: '/edits',        label: 'Edits',        Icon: PencilRuler,     end: false },
  { to: '/deliverables', label: 'Deliverables', Icon: Package2,        end: false },
  { to: '/meetings',     label: 'Meetings',     Icon: CalendarDays,    end: false },
  { to: '/reports',      label: 'Reports',      Icon: FileBarChart2,   end: false },
];

export default function TopNav() {
  return (
    <>
      {/* Desktop left rail — fixed, 252px, numbered items */}
      <nav className="rail" role="navigation" aria-label="Primary navigation">
        {TABS.map(({ to, label, Icon, end }, i) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            aria-label={label}
            style={{ textDecoration: 'none', display: 'block', width: '100%' }}
          >
            {({ isActive }) => (
              <span className="rail-item" data-active={isActive ? 'true' : 'false'}>
                <span className="ri-num">{String(i + 1).padStart(2, '0')}</span>
                <Icon size={17} strokeWidth={isActive ? 2.5 : 2} aria-hidden="true" style={{ flexShrink: 0 }} />
                <span className="ri-label">{label}</span>
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Mobile bottom tab bar — fixed, hidden on desktop */}
      <nav className="bbar" role="navigation" aria-label="Primary navigation">
        {TABS.map(({ to, label, Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            aria-label={label}
            style={{ textDecoration: 'none', display: 'flex', flex: '1 1 0' }}
          >
            {({ isActive }) => (
              <span className="bbar-item" data-active={isActive ? 'true' : 'false'} style={{ width: '100%' }}>
                <Icon size={20} strokeWidth={isActive ? 2.5 : 2} aria-hidden="true" />
                <span>{label}</span>
              </span>
            )}
          </NavLink>
        ))}
      </nav>
    </>
  );
}
